<template>
    <div style="margin-top:30PX; height: 100%;" :class="{'mobileChange': mobile == 1}">
        <div class="main">
            <div class="main-title" v-if="isUserState == 0"><h2 >{{$t('freezing.AccountEnable')}}</h2></div>
            <div class="main-title" v-if="isUserState == 1"><h2 >{{$t('freezing.accountDisabled')}}</h2></div>
        </div>
        <div class="card-div"  v-if="!dialogVisible">
            <div >
                <h3 v-if="isAccountOk == 0">{{$t('freezing.confirmInfor')}}</h3>
                <h3 v-if="isAccountOk == 1">{{$t('freezing.successActiviva')}}</h3>
                <h3 v-if="isAccountOk == 2">{{$t('freezing.disableSuccess')}}</h3>
                <p v-if="isUserState == 0 && isAccountOk == 0" style="margin-top:15PX;" class="toptip">{{$t('freezing.currentDisabled')}}</p>
            </div>
            <div class="user-div">
                <span>{{$t('freezing.UID')}}</span> <p>{{data.userId}}</p><br>
                <span>{{$t('freezing.currentName')}}</span> <p>{{data.username}}</p>
                <br>
                <span v-if="isUserState == 1 && isAccountOk == 0"  class="notes">{{$t('freezing.note')}}</span>
            </div>
            <div class="btn-div" v-if="isAccountOk == 0">
                <el-button class="btn btn-no" type="primary" @click="outBtn()">{{$t('freezing.no')}}</el-button>
                <el-button class="btn" type="primary" @click="yes()">{{$t('freezing.yes')}}</el-button>
            </div>
            <div class="btn-div btnSure" v-if="isAccountOk != 0">
                <el-button class="btn" type="primary" @click="goHome()">{{$t('help.sure')}}</el-button>
            </div>
            
        </div>
        <div v-if="dialogVisible">
              <div class="dialogLink">
                    <span class="DialoglinkExpired">{{$t('freezing.linkExpired')}} </span>
                    <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="errOk ">{{$t('help.sure')}}</el-button>
                    </span>
                </div>
        </div>
        <!-- <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%"
        :center="true"
        :fullscreen="true"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <span>{{$t('freezing.linkExpired')}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="errOk ">{{$t('help.sure')}}</el-button>
        </span>
      </el-dialog> -->
        
    </div>
</template>

<script>
  import {isEmail,isPsw,isMobile} from "../../utils/validate";
  import {setCapture} from "../../utils";
  import apiUrl from '@/utils/api'  //api 接口


export default {
  props: ['mobile'],
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
        data:{
            userId: "",
            areacode:"+86",
            username:"",
            verifyToken:"",
            realm:"",

        },
        isAccountOk:0,
        isUserState:1,
        dialogVisible:false

    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
        goHome(){
            location.href = this.$baseUrl + "home-page" 
        },
        errOk(){
            location.href = this.$baseUrl + "home-page" 
        },
        yes(){
            var url = "";
            var _this = this;
            if(this.isUserState == 0){
                url= "accountinfo/appeal/reactive/account/v1"
            }else{
                url= "accountinfo/appeal/deactive/account/v1"
            }
            this.$http({
                method: 'post',
                url: this.$http.adornUrl(url),
                data: this.$http.adornData(this.data )
            }).then(data => {
                if (data.status === 200) {
                    if(this.isUserState == 1){
                        this.isAccountOk = 2
                        this.isUserState = 1
                    }else {
                        this.isAccountOk = 1
                        this.isUserState = 0
                    }
                }
            }).catch(err => {
                if (err.status !== 200) {
                    if(err.data.Code == "USS-0151"){
                        _this.$alert(this.$('appeal.requestLocked'), '', {
                        confirmButtonText: this.$t('help.sure'),
                        });
                    }else if (err.data.Code == "USS-0103"){
                        _this.$alert(this.$t('appeal.accountNotExist'), '', {
                        confirmButtonText: this.$t('help.sure'),
                        })
                    }else if(err.data.Code == "USS-0140"){
                        _this.$alert(this.$t('freezing.linkExpired'), '', {
                        confirmButtonText: this.$t('help.sure'),
                        })
                    }

                }
            })
        },
        outBtn(){
            location.href = this.$baseUrl + "home-page" 
        },
        //链接key值回调
        getauthnCode(){
            // var url = "http://idinner1.dev.surepush.cn/accountinfo/changeActiveState?EppDj3RrMfAh6C0O9GwgRXD409mxaiKPmMyKM3VY42uOok1FrdvQ3%2BoX5%2Bj%2BdPpn7PwDwMhcfx81DPr7SbLxxjs01sSNmEs7gET2hsSz2JtSEoH5yH4hbeKIMh91Akt2Xo15PDjI26C5VrzZHymTuctuZx5xKJlc%2FVMWKJktT82cyULUMr6n%2FuXdtH2ZvFY8"
            var url = location.href
            if(url.split("changeActiveState?")[1]){
                var getUrl = "/accountinfo/appeal/appealinfo/v1?encodeinfo=" + url.split("changeActiveState?")[1]
                fetch( getUrl, {
                        method: "GET",
                        mode: 'cors'
                        // credentials: "include"
                    }).then(response => response.json())
                    .then(data => {
                            this.data.userId=data.userId,
                            this.data.areacode=data.areacode,
                            this.data.username=data.username,
                            this.data.verifyToken=data.verifyToken,
                            this.data.realm=data.realm,
                            this.isUserState = data.userState
                    }).catch((err) => {
                        this.dialogVisible = true 
                    })
            }else{
                this.dialogVisible = true 

            }
        }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.imgUrl = setCapture(this.ttt);
      this.getauthnCode()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style >
.el-dialog__body{
  text-align: center !important;
  margin-top: 20%;
}
.el-button{
  padding: 12px 40px!important;
  font-size: 14px!important;
  border-radius: 4px!important;
  border: 1px solid #dcdfe6!important;
  font-size: 14px!important;
}

.el-dialog__body{
  text-align: center !important;
  margin-top: 20%;
}
.el-dialog{
  margin: 0 auto 50px!important;
  border-radius: 2px!important;
  box-shadow: 0 1px 3px rgba(0,0,0,.3)!important;
}
.el-dialog__header{
  padding: 20px 20px 10px!important;
}
.el-dialog__title{
    line-height: 24px!important;
    font-size: 18px!important;
}
.el-dialog__body{
      padding: 25px 25px 30px!important;
      font-size: 14px!important;
}
.el-dialog__footer{
  padding: 10px 20px 20px!important;
}
</style>
<style scoped lang="scss">
  .dialogLink{
    margin-top: 150PX;
    text-align: center;
    .DialoglinkExpired{
      display: block;
      font-size: 18PX;
      margin-bottom: 10PX;
      padding:0 10PX;
    }
  }
.user-div{
    margin-top: 30PX;
    span{
        line-height: 25PX;
        font-size: 14PX;
    }
    p{
        font-size: 13PX;
        display: inline-block;
    }
    .notes{
        color:#666!important;
        margin-top: 12PX;
        font-size: 12PX;
    }
}
.btn-div{
  margin-top: 40PX;
  .btn{
        width:190PX;
  }
  .btn-no{
      background-color:#B8B8B8 ;
      border-color:#B8B8B8 ;
  }
}
.main-title {
//   padding: 0 14%;
  border-bottom: 1PX solid #ddd;
  background-color: #ffffff;
  
  position: relative;
  overflow: hidden;
   h2{
        font-size:18PX;
        font-weight: bold;
        color:#666!important;
        padding: 25PX 14% 45PX 14%;
      }
    p{
        font-size:16PX;
        color:#666!important;
        margin-top: 12PX;
    }
}
.card-div {
  margin-top: 50PX;
  padding: 0 14%;
  overflow: hidden;
  margin-bottom: 80PX;
  p{
      color: #999999;
  }
  h3{
      font-size: 16PX;
  }
}
.toptip{
    font-size: 18PX;
}
.mobileChange{
    .main-title{
        padding:0 25PX;
        h2{
            padding: 25PX 0 45PX 0;
        }
    }
    .card-div{
        padding:0 25PX!important;
    }
    .btn-div{
        margin:20PX 30PX;
        padding: 20PX auto;
        .btn{
            width:115PX!important;
        }
    }
    .btnSure{
        text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/changeActiveState/changeActiveState.vue